(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.drawerUtilityLinks = this.querySelector('header-drawer .menu-drawer__utility-links');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      document.documentElement.style.setProperty('--utility-links-height', `${this.drawerUtilityLinks.offsetHeight}px`);

      window.matchMedia('(max-width: 999px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  // ------------------------------
  const detailsElements = document.querySelectorAll('header-menu details');

  // Detect touch device
  const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Touch device handling - toggle on tap, close others
  // Desktop hover behavior is handled in details-disclosure.js (HeaderMenu class)
  detailsElements.forEach((details) => {
    const summary = details.querySelector('summary');

    if (isTouchDevice()) {
      // Mobile/touch: toggle open/close on tap
      summary.addEventListener('click', (e) => {
        e.preventDefault();

        const isAlreadyOpen = details.hasAttribute('open');

        // Close all other menus
        detailsElements.forEach((d) => d.removeAttribute('open'));

        // If it was not open, open it (toggle behavior)
        if (!isAlreadyOpen) {
          details.setAttribute('open', '');
        }
      });
    } else {
      // Desktop: block click (hover opens menu via HeaderMenu class in details-disclosure.js)
      summary.addEventListener('click', (e) => e.preventDefault());
    }
  });

  // ------------------------------

  $(document).ready(() => {
    const updateHeaderMenuHeight = () => {
      const headerMenuHeight = $('.header > .header__inline-menu').outerHeight();
      if (headerMenuHeight) {
        document.documentElement.style.setProperty('--header-menu-height', `${headerMenuHeight}px`);
      }
    };

    // Run on load
    updateHeaderMenuHeight();

    // Run on resize (debounced for performance)
    let resizeTimeout;
    $(window).on('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateHeaderMenuHeight, 150);
    });

    // Move mega menu content to in-flow panel (under header) when open, back when closed
    const headerWrapper = document.querySelector('.header-wrapper');
    const panel = document.getElementById('mega-menu-panel');
    if (headerWrapper && panel) {
      const moveContentBackToDetails = (content) => {
        const detailsId = content.dataset.detailsId;
        if (detailsId) {
          const details = document.getElementById(detailsId);
          if (details) details.appendChild(content);
          delete content.dataset.detailsId;
        }
      };

      const moveContentToPanel = (details) => {
        const content = details.querySelector('.mega-menu__content');
        if (content) {
          content.dataset.detailsId = details.id;
          panel.appendChild(content);
          panel.setAttribute('aria-hidden', 'false');
        }
      };

      const onMegaMenuOpenChange = (details, isOpen) => {
        if (isOpen) {
          // When opening, swap content: move old out (if any), move new in
          const currentContent = panel.firstElementChild;
          if (currentContent) moveContentBackToDetails(currentContent);
          moveContentToPanel(details);
        } else {
          // When closing, only move content out if NO other menu is open
          // This prevents the panel from becoming empty during menu-to-menu transitions
          const anyMenuOpen = headerWrapper.querySelector('details.mega-menu[open]');
          if (anyMenuOpen) {
            // Another menu is open (or opening), it will handle the content swap
            return;
          }
          const content = panel.firstElementChild;
          if (content && content.dataset.detailsId === details.id) {
            moveContentBackToDetails(content);
          }
          if (!panel.firstElementChild) panel.setAttribute('aria-hidden', 'true');
        }
      };

      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'open') {
            const details = m.target;
            if (details.classList.contains('mega-menu')) {
              onMegaMenuOpenChange(details, details.hasAttribute('open'));
            }
            break;
          }
        }
      });

      headerWrapper.querySelectorAll('details.mega-menu').forEach((details) => {
        observer.observe(details, { attributes: true });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
